import { Type } from 'class-transformer';
import { IsArray, IsDate, IsOptional, IsString, IsUUID, ValidateNested } from 'class-validator';
import { LabelConfirmationParticipantDto } from './label-confirmation-participant.dto';

/**
 * Append-only: a correction never edits this row, it creates a new one and
 * links back via `supersededById` on the record it replaces (set by the
 * service, not exposed as a writable field here).
 */
export class CounterLabelConfirmationResponseDto {
  @IsUUID()
  id!: string;

  @IsUUID()
  counterLabelDataId!: string;

  @IsDate()
  confirmedAt!: Date;

  @IsOptional()
  @IsUUID()
  confirmedById?: string | null;

  @IsString()
  confirmedByName!: string;

  @IsOptional()
  @IsString()
  signatureStorageKey?: string | null;

  @IsString()
  payloadHash!: string;

  payloadSnapshot!: Record<string, unknown>;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => LabelConfirmationParticipantDto)
  participants!: LabelConfirmationParticipantDto[];

  @IsOptional()
  @IsUUID()
  supersededById?: string | null;

  @IsOptional()
  @IsString()
  correctionReason?: string | null;
}
